import { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import FBIcon from "../../icons/links/facebook_f.svg";
import {
  ClockIcon,
  CalendarIcon,
  LocationIcon,
  // ChevronLeftIcon,
} from "../../../components/page-components/icons";
import { stockImages } from "../../../services/stockImages";
import { format, isSameDay } from "date-fns";
import parse from "html-react-parser";

export const EventCardForPendingVendor = ({
  eventImage,
  eventName,
  // eventLocation,
  eventStart,
  eventEnd,
  eventHours,
  eventUrl,
  legacy = "",
  eventHoursStart,
  eventHoursEnd,
  eventStreet1,
  eventCity,
  legacyEvent,
  safetyCheck = false,
  facebookUrl,
  eventId,
  eventStatus,
}) => {
  const checkImage = () => {
    if (eventImage && eventImage.startsWith("http")) {
      setImage(eventImage);
    } else {
      for (const img of stockImages) {
        if (eventName.toLowerCase().includes(img.venue)) {
          setImage(img.stockImage);
        }
      }
    }
  };

  const [image, setImage] = useState();

  const getFormattedDate = (date) => {
    if (date !== false || date !== "InvalidDate") {
      try {
        return format(date, "MMM do, yyyy");
      } catch (err) {
        console.log(err);
        return null;
      }
    } else {
      return null;
    }
  };

  const getFormattedTime = (time) => {
    if (time !== false || time !== "InvalidDate") {
      try {
        return format(time, "h:mm aa");
      } catch (err) {
        console.log(err);
        return null;
      }
    } else {
      return null;
    }
  };

  useEffect(() => {
    checkImage();
  }, [image]);

  return (
    <div className="event_card">
      <div className="event_card_img">
        <Image
          alt="image of event"
          src={
            image
              ? image
              : "https://res.cloudinary.com/dkceblkn7/image/upload/v1643205862/stock%20images/boho-market-dallas-texas-1_oc6bjq.jpg"
          }
          layout="fill"
          objectFit="cover"
        />
      </div>
      <div className="event__card__content">
        <h4>{eventName}</h4>
        
          <div>
            <LocationIcon className="icon--sm" color="accent-light" />

            <p className="font-xl-bold">
              {eventStreet1}, {eventCity}
            </p>
          </div>
        
        {/* NOTE the addresses are in the venue, not the events, so without cross referencing we won't have the address */}
        <div>
          <CalendarIcon className="icon--sm" color="accent-light" />
            <p>
              {eventStart === null && eventEnd === null
                ? "Dates TBD"
                : isSameDay(eventStart, eventEnd)
                ? `On ${getFormattedDate(eventStart)}`
                : `From ${getFormattedDate(eventStart)} to
            ${getFormattedDate(eventEnd)}`}
            </p>
          
        </div>
        {eventId === 48 ? (
          <>
            <div>
              <ClockIcon className="icon--sm" color="accent-light" />
              <p>October 8th: From 12:00 PM to 8:00 PM</p>
            </div>
            <div>
              <ClockIcon className="icon--sm" color="accent-light" />
              <p>October 9th: From 12:00 PM to 5:00 PM</p>
            </div>
          </>
        ) : (
          <>
            <div>
              <ClockIcon className="icon--sm" color="accent-light" />

              {eventHours && <p>{parse(eventHours)}</p>}
                <p>
                  {eventStart === null && eventEnd === null
                    ? "Dates TBD"
                    : `From ${getFormattedTime(eventHoursStart)} to
            ${getFormattedTime(eventHoursEnd)}`}
                </p>
              {/* {eventHoursStart && eventHoursEnd && (
            <p>
              {`From ${format(
                eventStart + eventHoursStart,
                "h:mm aa",
              )} to ${format(eventHoursEnd, "h:mm aa")}`}
            </p>
          )} */}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default EventCardForPendingVendor;
